import clsx from 'clsx';
import * as React from 'react';

type SeparatorProps = {
	text?: string;
	className?: string;
	classNameText?: string;
};

export const Separator: React.FC<SeparatorProps> = ({
	text,
	className,
	classNameText,
}) => {
	return (
		<div className={clsx('relative w-full', className)}>
			<div className="absolute inset-0 flex items-center" aria-hidden="true">
				<div className="w-full border-t border-opacity-primary" />
			</div>
			<div className="relative flex justify-center">
				<span
					className={clsx(
						'bg-white px-4 text-base text-opacity-black',
						classNameText
					)}
				>
					{text}
				</span>
			</div>
		</div>
	);
};
